import {
  Alert,
  Avatar,
  Button,
  Chip,
  Divider,
  Input,
  Progress,
  Skeleton,
  Tab,
  Tabs,
  Snackbar,
  Popup,
  Uploader,
  Loading,
  Select,
  Switch,
} from '@varlet/ui';
import type { App as VueApp } from 'vue';
import '@varlet/ui/es/alert/style';
import '@varlet/ui/es/avatar/style';
import '@varlet/ui/es/button/style';
import '@varlet/ui/es/chip/style';
import '@varlet/ui/es/divider/style';
import '@varlet/ui/es/input/style';
import '@varlet/ui/es/progress/style';
import '@varlet/ui/es/skeleton/style';
import '@varlet/ui/es/tab/style';
import '@varlet/ui/es/tabs/style';
import '@varlet/ui/es/snackbar/style';
import '@varlet/ui/es/popup/style';
import '@varlet/ui/es/uploader/style';
import '@varlet/ui/es/loading/style';
import '@varlet/ui/es/select/style';
import '@varlet/ui/es/switch/style';

const components: Readonly<any[]> = [
  Alert,
  Avatar,
  Button,
  Chip,
  Divider,
  Input,
  Progress,
  Skeleton,
  Tab,
  Tabs,
  Snackbar,
  Popup,
  Uploader,
  Loading,
  Select,
  Switch,
] as const;

const initUiComponents = (app: VueApp<Element>) => {
  for (const component of components) {
    app.use(component);
  }
};

export { initUiComponents };
